/*******************************************************************************
 * @ngdoc    object
 * @name     ClassInfo
 * @module   csm.books.services.NewBooksData
 * @constructor
 * @param {object=} info  Class info read from database.
 * @description
 * Class information.
 *******************************************************************************/
ClassInfoConfig.$inject = ['TypeFactoryProvider'];
/* @ngInject */ export function ClassInfoConfig(TypeFactoryProvider) {
  /*------------------------------------------*/
  /* Using defaults rather than prototype to  */
  /* make sure default values get serialized. */
  /*------------------------------------------*/
  var defaults = {
    id: 0, // Class ID.
    organizationID: 0, // Organization ID.
    type: 0, // Class Type. Read-Only
    name: null, // Class Name.
    active: true // Active.
  };

  TypeFactoryProvider.addType({
    name: 'NewBooksData.ClassInfo',
    $type: 'csm.booksdb.data.ClassInfo, CSMBooksDBCS',
    constructor: function () {
      return function (data) {
        this.defaultConstructor(Object.assign({}, defaults, data));
      };
    }
  });
}
